import { supabase } from '../lib/supabase';
import type { CreatorCode, CreatorOnboarding, CreatorOverview, CreatorPayout, CreatorWorkspaceData } from './types';

/* eslint-disable @typescript-eslint/no-explicit-any */

// All three reads are partner-scoped, aggregate-only security-definer RPCs — the
// creator's own anon JWT is the gate; the service-role key never touches the
// browser, and a referred customer's identity never leaves Postgres.
export async function loadCreatorWorkspace(): Promise<CreatorWorkspaceData> {
  const [overviewResult, codesResult, payoutsResult, onboardingResult] = await Promise.all([
    supabase.rpc('partner_os_creator_overview'),
    supabase.rpc('partner_os_creator_codes'),
    supabase.rpc('partner_os_creator_payouts'),
    supabase.rpc('partner_os_creator_onboarding'),
  ]);
  for (const result of [overviewResult, codesResult, payoutsResult, onboardingResult]) {
    if (result.error) throw new Error(result.error.message);
  }

  const o = overviewResult.data as any;
  const overview: CreatorOverview = {
    handle: o.handle,
    displayName: o.displayName,
    tier: o.tier,
    status: o.status,
    planName: o.planName,
    minPayoutCents: Number(o.minPayoutCents),
    availableCents: Number(o.availableCents),
    onHoldCents: Number(o.onHoldCents),
    paidCents: Number(o.paidCents),
    lifetimeCents: Number(o.lifetimeCents),
    reversedCents: Number(o.reversedCents),
    referredCount: Number(o.referredCount),
    payingCount: Number(o.payingCount),
    payoutReady: Boolean(o.payoutReady),
    disclosure: o.disclosure,
  };

  const codes: CreatorCode[] = ((codesResult.data ?? []) as any[]).map((c) => ({
    code: c.code,
    active: Boolean(c.active),
    referredCount: Number(c.referred_count),
    payingCount: Number(c.paying_count),
  }));

  const payouts: CreatorPayout[] = ((payoutsResult.data ?? []) as any[]).map((p) => ({
    id: p.id,
    periodStart: p.period_start,
    periodEnd: p.period_end,
    amountCents: Number(p.amount_cents),
    status: p.status,
    issuedAt: p.issued_at ?? null,
  }));

  return { overview, codes, payouts, onboarding: onboardingResult.data as CreatorOnboarding | null };
}
